module.exports = __webpack_public_path__ + "static/media/notification_mention.692e5be4.svg";